import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components/macro';

export const ScNetworks = styled.div`
  position: relative;

  @media (${device.mobile}) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  & > .content {
    position: relative;
    padding: 32px 24px;
    width: 100%;
    max-width: 360px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    z-index: 2;

    & > .description {
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0.01em;
      text-align: center;
      color: ${({ theme }) => theme.whiteColor};
    }

    & > .networks {
      display: flex;
      flex-direction: column;
      row-gap: 8px;
      width: 100%;

      & > div {
        padding: 8px 0;
        background: linear-gradient(
          90deg,
          rgba(42, 171, 238, 0) 0%,
          rgba(42, 171, 238, 0.4) 50.52%,
          rgba(42, 171, 238, 0) 100%
        );

        & > a {
          display: flex;
          align-items: center;
          justify-content: center;
          column-gap: 12px;
          font-size: 14px;
          font-weight: 700;
          line-height: 20px;
          color: ${({ theme }) => theme.whiteColor};

          & > svg:first-child {
            width: 40px;
            height: 40px;

            & > rect + path,
            & > rect + g {
              transform-origin: center;
              transition: scale 0.2s ease-in-out;
            }
          }

          & > span + svg {
            rotate: 180deg;
            & path {
              transition: fill 0.2s ease-in-out;
            }
          }

          @media (hover: hover) {
            &:hover {
              & > svg:first-child rect + path,
              & > svg:first-child rect + g {
                scale: 1.2;
              }
              & > span + svg path {
                fill: ${({ theme }) => theme.whiteColor};
              }
            }
          }
        }
      }
    }
  }

  .character {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 280px;
    object-fit: contain;
    z-index: 2;
    @media (${device.mobile}) {
      margin-top: 32px;
      position: static;
    }
  }

  @media (${device.mobileS}) {
    & > .content {
      padding: 0;

      & > .description {
        padding: 0 12px;
      }

      & > .action-btn {
        padding: 0 12px 32px;
        button {
          max-width: 100%;
        }
      }
    }

    .character {
      width: auto;
      height: 290px;
    }
  }
`;
